export default "__VITE_ASSET__BfJWiy_W__"